import React from 'react';

import { getSystemTypeConfig } from 'features/systems/config/system-type-registry';
import { SystemType } from 'features/systems/domain/models/system';

type Props = {
  systemType: SystemType;
  children: React.ReactNode;
};

const SystemTypeProviderWrapper = ({ systemType, children }: Readonly<Props>): React.JSX.Element => {
  const config = getSystemTypeConfig(systemType);
  const Provider = config.Provider;

  if (!Provider) {
    return <>{children}</>;
  }

  return <Provider>{children}</Provider>;
};

export default SystemTypeProviderWrapper;
